import styled from 'styled-components'

const Svg = styled.svg`
  object-fit: contain;
  object-position: center;
  width: 100%;
  height: 100%;
`
const NoWine = () => (
  <Svg
    width='156'
    height='620'
    viewBox='0 0 156 620'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M155.968 582.095V215.984C155.968 167.198 101.686 153.224 101.686 135.974C101.686 118.723 101.686 51.1216 101.686 51.1216C106.805 48.838 105.848 38.4326 105.848 38.4326L103.284 13.392C102.643 -1.5727 78.0039 0.051682 78.0039 0.051682C78.0039 0.051682 53.3567 -1.5727 52.7236 13.392L50.16 38.4326C50.16 38.4326 49.2025 48.838 54.3219 51.1216C54.3219 51.1216 54.3219 118.972 54.3219 135.974C54.3219 152.975 0.0317864 167.19 0.0317864 215.977V582.095C0.0317864 582.095 -3.97569 620 78.0039 620C159.976 620 155.968 582.095 155.968 582.095Z'
      fill='#F3F3F5'
    />
  </Svg>
)

export default NoWine
